export default {
  envStr: 'prodHuadong1',
  appName: '方舟物联网平台',
  apiHost: '/fenydata-java-gateway',
  docUrl: 'http' + '://i.fenydata.com/doc',
}